import { Component, h } from 'preact'
import { ColorResult, SketchPicker } from 'react-color'
import GlobalClick from '../interactive/documentClick'
import InputGroup from '../ui-components/InputGroup'
import tinycolor from 'tinycolor2'

interface Props {
  color: string | null,
  colorKey?: string,
  disabled: boolean,
  isColorSelectorEnabled: boolean,
  updateColor: (color: string) => void,
  disableColorSelector: () => void,
  setColorSelector: () => void,
  disableAlpha?: boolean,
  presetColors?: Array<string>
}

interface State {
}

export default class ColorPicker extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {}

    this.updateColors = this.updateColors.bind(this)
  }

  updateColors (color: ColorResult | string) {
    let newHexColor: string

    if (typeof color !== 'string') {
      newHexColor = tinycolor(color.rgb).toHex8String()
    } else {
      newHexColor = color
    }

    if (newHexColor.length === 9 && newHexColor.substring(7) === 'ff') {
      newHexColor = newHexColor.substring(0, 7)
    }
    const isHexValid = /^#([0-9A-F]{3}|[0-9A-F]{6}|[0-9A-F]{8})$/i.test(newHexColor)

    if (!isHexValid) {
      return
    }

    this.props.updateColor(newHexColor)
  }

  render ({ color, disabled, disableColorSelector, setColorSelector, presetColors, isColorSelectorEnabled, disableAlpha }: Props,  _: State) {
    if (color && color.length === 9 && color.substring(7) === 'ff') {
      color = color.substring(0, 7)
    }
    return (
      <GlobalClick onGlobalClick={disableColorSelector}>
        <div className={`theme-configuration--color-selector color-selector-wrapper ${disabled ? 'disabled' : ''}`}>
          <div className='theme-configuration--color-visual color-visual' onClick={setColorSelector}>
            <div style={{ backgroundColor: color }} className='color-preview' />
            <InputGroup
              title=''
              type='text'
              onKeyUp={(e: {target: HTMLInputElement}) => this.updateColors(e.target.value)}
              value={color || ''} />
          </div>
          <div className='theme-configuration--color-selector color-selector'>
            {
              isColorSelectorEnabled ? (
                <SketchPicker
                  disableAlpha={!!disableAlpha}
                  color={color || ''}
                  presetColors={presetColors || []}
                  onChangeComplete={(color) => this.updateColors(color)}
                />) : null
            }
          </div>
        </div>
      </GlobalClick>
    )
  }
}